











































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AntecipacaoRecebiveisStore from '@/components/RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'
import AntecipacaoCarteira from '@/components/Recebimento/AntecipacaoCarteira.vue'
import HistoricoAntecipacoes from '@/components/Recebimento/HistoricoAntecipacoes.vue'
import { maskMoney } from '@/utils/common'

@Component({
  components: { AntecipacaoCarteira, HistoricoAntecipacoes },
})
export default class ViewAntecipacao extends Vue {
  modalCarteira: boolean = false

  mostrarHistorico: boolean = false

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get valorTotal(): number | null {
    return this.getAntecipacaoStore.valorTotal
  }

  get antecipacoesDisponiveis(): any[] {
    return this.getAntecipacaoStore.antecipacaoProfissional || []
  }

  get temCredito(): boolean {
    return this.antecipacoesDisponiveis.length > 0
      && this.valorTotal !== null
      && this.valorTotal !== undefined
      && this.valorTotal > 0
  }

  get semCredito(): boolean {
    return !this.temCredito
  }

  get saldoLabel(): string {
    if (this.semCredito) {
      return 'Saldo disponível: R$ 0,00'
    }
    return `Saldo disponível: ${maskMoney(String(this.valorTotal))}`
  }

  get saldoTooltip(): string {
    return 'Aguardando a próxima avaliação de crédito para saldo de antecipações'
  }

  abrirCarteira() {
    this.modalCarteira = true
    this.getAntecipacaoStore.getAntecipacaoProfissional()
  }

  async atualizarDisponiveis() {
    await this.getAntecipacaoStore.getAntecipacaoProfissional()
  }

  async mounted() {
    await this.getAntecipacaoStore.getAntecipacaoProfissional()
  }
}
